export default __webpack_public_path__ + "static/char-v-13-8e0df8ce5d8b478318ddbd336654616e.webp";